import React, { Component }  from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import requester from '../../lib/requester'
import _ from 'lodash'

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            curTime: '',
            user: JSON.parse(window.localStorage.getItem('is_user')) || {},
            sidebarRoutes: []
        };
    }

    componentDidMount() {
        this.getSideBarRoutes()
        var menu = $('.sidebar-menu'), subMenuSelector = '.sidebar-submenu', animationSpeed = 300;
        $(menu).on('click', 'li a', function (e) {
            var $this = $(this);
            var checkElement = $this.next();

            if (checkElement.is(subMenuSelector) && checkElement.is(':visible')) {
                checkElement.slideUp(animationSpeed, function () {
                checkElement.removeClass('menu-open');
                });
                checkElement.parent("li").removeClass("active");
                $this.find('.submenu-arrow').removeClass('openSubmenu')
            }

            //If the menu is not visible
            else if ((checkElement.is(subMenuSelector)) && (!checkElement.is(':visible'))) {
                //Get the parent menu
                var parent = $this.parents('ul').first();
                //Close all open menus within the parent
                var ul = parent.find('ul:visible').slideUp(animationSpeed);
                //Remove the menu-open class from the parent
                ul.removeClass('menu-open');
                //Get the parent li
                var parent_li = $this.parent("li");
                ul.parents('li').find('.submenu-arrow').removeClass('openSubmenu')

                //Open the target menu and add the menu-open class
                checkElement.slideDown(animationSpeed, function () {
                    //Add the class active to the parent li
                    checkElement.addClass('menu-open');
                    parent.find('li.active').removeClass('active');
                    // parent.find('.submenu-arrow').addClass('openSubmenu');
                    parent_li.addClass('active');
                    $this.find('.submenu-arrow').addClass('openSubmenu')
                });
            }
            //if this isn't a link, prevent the page from being redirected
            if (checkElement.is(subMenuSelector)) {
                e.preventDefault();
            }
        });
    }

    getSideBarRoutes = () => {
        requester.getInfostep('/api/infostep/v1/general/menu?userId=' + this.state.user.user_id, {
            success: function(response) {
                let data = response.data.data
                let container = []

                // Level 1
                data.forEach((item, index) => {
                    if (item.is_group === 'Y') {
                        container.push({
                            menu_id: item.menu_id,
                            parent_id: item.parent_id,
                            is_group: item.is_group,
                            menu: item.menu,
                            icon: item.icon,
                            url_path: item.url_path,
                            child: []
                        })
                    } else if (item.parent_id === 0) {
                        container.push({
                            menu_id: item.menu_id,
                            parent_id: item.parent_id,
                            is_group: item.is_group,
                            menu: item.menu,
                            icon: item.icon,
                            url_path: item.url_path
                        })
                    }
                })

                // Level 2
                let indexing = -1
                data.forEach((item, index) => {
                    indexing = _.findIndex(container, function (menu) {
                        return menu.menu_id === item.parent_id 
                    });
                    if (indexing >= 0) {
                        container[indexing].child.push({
                            menu_id: item.menu_id,
                            parent_id: item.parent_id,
                            is_group: item.is_group,
                            menu: item.menu,
                            icon: item.icon,
                            url_path: item.url_path,
                            child: []
                        })
                    }
                })

                // Level 3
                let subindexing = -1
                data.forEach((item, index) => {
                    container.forEach((itemsub, indexsub) => {
                        subindexing = _.findIndex(itemsub.child, function(o) {
                            return o.menu_id === item.parent_id
                        })
                        if (subindexing >= 0) {
                            container[indexsub].child[subindexing].child.push({
                                menu_id: item.menu_id,
                                parent_id: item.parent_id,
                                is_group: item.is_group,
                                menu: item.menu,
                                icon: item.icon,
                                url_path: item.url_path,
                                child: []
                            });
                            // if(item.menu_id === 8){
                            //     container[indexsub].child[subindexing].child.push({
                            //         menu_id: 999,
                            //         parent_id: 7,
                            //         is_group: null,
                            //         menu: 'Approval DXM',
                            //         icon: null,
                            //         url_path: '/admin/claim/approval-dxm',
                            //         child: []
                            //     })
                            // }
                        }
                    })
                })

                this.setState({ sidebarRoutes: container })
            }.bind(this),
            error: function(e) {
                console.log(e)
            }
        })
    }

    renderArrow = (child) => {
        if (child > 0) {
            return (<i className="submenu-arrow float-right mt-1 fas fa-angle-left" size="xs" />)
        }
    }

    hasSUb = (child) => {
        return (child > 0) ? 'nav nav-treeview sidebar-submenu' : 'nav nav-treeview'
    }

    render() {
        return(
            <div>
                <aside className="main-sidebar sidebar-dark-primary elevation-4" id="aside-sidebar">
                    <a href="index3.html" className="brand-link">
                        <span className="brand-text font-weight-light">INFOSTEP</span>
                    </a>
                    <div className="sidebar">
                        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                            <div className="image my-auto">
                                <img src={ require('../../assets/img/avatar5.png')} className="img-circle elevation-2" alt="User Profile" />
                            </div>
                            <div className="info">
                                <Link to="#" className="d-block">{ this.state.user.realname } <br /> { this.state.user.role_name }</Link>
                            </div>
                        </div>
                        <div className="mt-2 sidebar-wrapper">
                            <ul className="nav nav-pills nav-sidebar flex-column sidebar-menu" data-widget="treeview" role="menu" data-accordion="false">
                                <li className="nav-item">
                                    <Link to="/admin/dashboard" className="nav-link">
                                        <div className="row">
                                            <div className="col-2 text-center"><i className="nav-icon fas fa-tachometer-alt" /></div>
                                            <div className="col-10">Dashboard</div>
                                        </div>
                                    </Link>
                                </li>
                                {
                                    this.state.sidebarRoutes.map((item, index) => {
                                        return (
                                            <li className="nav-item" key={index}>
                                                <Link to="#" className="nav-link">
                                                    <div className="row">
                                                        <div className="col-2 text-center"><i className={ item.icon } /></div>
                                                        <div className="col-9">{ item.menu }</div>
                                                        <div className="col-1 float-left">{ this.renderArrow(item.child.length) }</div>
                                                    </div>
                                                </Link>
                                                <ul className={ this.hasSUb(item.child.length) }>
                                                    {
                                                        item.child.map((itemsub, indexsub) => {
                                                            return (
                                                                <li className="nav-item" key={indexsub}>
                                                                    <Link to={ itemsub.url_path } className="nav-link">
                                                                        <div className="row">
                                                                            <div className="col-2 text-center"><i className={ itemsub.icon } /></div>
                                                                            <div className="col-9">{ itemsub.menu }</div>
                                                                            <div className="col-1 float-left">{ this.renderArrow(itemsub.child.length) }</div>
                                                                        </div>
                                                                    </Link>
                                                                    <ul className={ this.hasSUb(item.child.length)}>
                                                                        {
                                                                            itemsub.child.map((itemsub2, indexsub2) => {
                                                                                return (
                                                                                    <li className="nav-item" key={indexsub2}>
                                                                                        <Link to={ itemsub2.url_path } className="nav-link">
                                                                                            <div className="row">
                                                                                                <div className="col-2 text-center"><i className={ itemsub2.icon } /></div>
                                                                                                <div className="col-9">{ itemsub2.menu }</div>
                                                                                                <div className="col-1 float-left"></div>
                                                                                            </div>
                                                                                        </Link>
                                                                                    </li>
                                                                                )
                                                                            })
                                                                        }
                                                                    </ul>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </aside>
            </div>
        )
    }
}

export default Sidebar